import { apiFetch } from './auth-service';

// ── Idea Submissions ──────────────────────────────────────────────────────────

export interface IdeaDoc {
  _id: string;
  title: string;
  problemStatement: string;
  proposedSolution: string;
  targetMarket: string;
  uniqueValueProp: string;
  status: 'draft' | 'submitted' | 'approved' | 'revision_needed' | 'rejected';
  submittedAt?: string;
  mentorFeedback?: string;
  startupId?: { _id: string; name: string } | string;
  userId?: { _id: string; name: string; email: string } | string;
  createdAt?: string;
}

export const getMyIdeas = (): Promise<IdeaDoc[]> =>
  apiFetch.get<{ idea: IdeaDoc | null }>('/ideas/mine').then(r => (r.idea ? [r.idea] : []));

export const submitIdea = (data: Partial<IdeaDoc>): Promise<IdeaDoc> =>
  apiFetch.put<{ idea: IdeaDoc }>('/ideas/mine', data).then(r => r.idea);

export const getAllIdeasForReview = (): Promise<IdeaDoc[]> =>
  apiFetch.get<{ ideas: IdeaDoc[] }>('/ideas').then(r => r.ideas);

export const getIdeaById = (id: string): Promise<IdeaDoc> =>
  apiFetch.get<{ idea: IdeaDoc }>(`/ideas/${id}`).then(r => r.idea);

export const reviewIdea = (id: string, status: string, mentorFeedback: string): Promise<IdeaDoc> =>
  apiFetch.put<{ idea: IdeaDoc }>(`/ideas/${id}/review`, { status, mentorFeedback }).then(r => r.idea);

// ── Phase Pitch Submissions ───────────────────────────────────────────────────

export interface PhasePitchDoc {
  _id: string;
  problem: string;
  solution: string;
  marketSize: string;
  businessModel: string;
  traction: string;
  team: string;
  financials: string;
  askAmount: string;
  useOfFunds: string;
  competitiveAdvantage: string;
  fileUrl?: string;
  fileKey?: string;
  fileName?: string;
  fileSize?: number;
  status: 'draft' | 'submitted' | 'approved' | 'revision_needed' | 'rejected';
  publishedForInvestors?: boolean;
  submittedAt?: string;
  mentorNotes?: string;
  startupId?: { _id: string; name: string } | string;
  userId?: { _id: string; name: string; email: string } | string;
  createdAt?: string;
}

export const getMyPitches = (): Promise<PhasePitchDoc[]> =>
  apiFetch.get<{ pitch: PhasePitchDoc | null }>('/phase-pitches/mine').then(r => (r.pitch ? [r.pitch] : []));

export const submitPitch = (data: Partial<PhasePitchDoc>): Promise<PhasePitchDoc> =>
  apiFetch.put<{ pitch: PhasePitchDoc }>('/phase-pitches/mine', data).then(r => r.pitch);

export const getAllPitchesForReview = (): Promise<PhasePitchDoc[]> =>
  apiFetch.get<{ pitches: PhasePitchDoc[] }>('/phase-pitches').then(r => r.pitches);

export const getPitchById = (id: string): Promise<PhasePitchDoc> =>
  apiFetch.get<{ pitch: PhasePitchDoc }>(`/phase-pitches/${id}`).then(r => r.pitch);

export const reviewPitch = (id: string, status: string, mentorNotes: string): Promise<PhasePitchDoc> =>
  apiFetch.put<{ pitch: PhasePitchDoc }>(`/phase-pitches/${id}/review`, { status, mentorNotes }).then(r => r.pitch);


export const getApprovedPitches = (): Promise<PhasePitchDoc[]> =>
  apiFetch.get<{ pitches: PhasePitchDoc[] }>('/phase-pitches').then(r =>
    r.pitches.filter(p => p.status === 'approved')
  );
